import { FC } from 'react'
import classes from '../../styles/checkbox.module.scss'
import cn from 'classnames'

export const Checkbox: FC<{ 
  isChecked: boolean;
  variant?: 'default' | 'inverted'
  handleCheckboxChange: (e?: any) => void 
}> = ({
  isChecked,
  handleCheckboxChange,
  variant = 'default'
}) => {
  return (
    <label style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
      <input
        className={cn(classes.checkBoxInput, variant === 'inverted' && classes.checkBoxInputInverted)}
        type="checkbox" checked={isChecked}
        onChange={handleCheckboxChange}
      />
    </label>
  )
}
